export default "__VITE_ASSET__XUacRrac__"